<script>
import LogAddAction from '@/components/Log/LogAddAction.vue';
import LogToggleTableAction from '@/components/Log/LogToggleTableAction.vue';
import LogDownloadAction from '@/components/Log/LogDownloadAction.vue';
import { mapState } from 'vuex';

export default {
  components: {
    LogAddAction,
    LogToggleTableAction,
    LogDownloadAction,
  },
  computed: {
    ...mapState('globalState/app', ['openMenu']),
    customWidth() {
      return this.openMenu ? '80.5vw' : '92.5vw';
    },
  },
};
</script>

<template>
  <div class="action-bar-container">
    <div><LogToggleTableAction /></div>
    <div class="log-actions-container">
      <LogAddAction />
      <LogDownloadAction />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.action-bar-container {
  @include flex-center-justify(space-between);
  margin-bottom: 1rem;
  width: v-bind(customWidth);
}
.log-actions-container {
  display: flex;
}
</style>
